document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.cta-button').forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      let formElement = document.querySelector(".globo-formbuilder-wizard");

      if (formElement) {
        formElement.scrollIntoView({ behavior: "smooth" });
      } else {
        console.error("⚠️ Formular nicht gefunden! Prüfe die Klasse.");
      }
    });
  });
});
